export default __webpack_public_path__ + "static/media/a60c0888b231a032.369b0f6d62375b15f591cf55d292f741.svg";